import marketingInstance from '../instance'

const storeFlyerCoupon = (data) => {
	return marketingInstance.post('/flyerCoupons', data)
}

export default storeFlyerCoupon
